export default "__VITE_ASSET__CHgBw1sb__"